webpackJsonp([5],{

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  max-width: 1000px;\n  margin: auto;\n  width: 80%;\n  margin-top: 10%;\n  background-color: #150a1c;\n  height: auto;  \n  padding: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n'], ['\n  max-width: 1000px;\n  margin: auto;\n  width: 80%;\n  margin-top: 10%;\n  background-color: #150a1c;\n  height: auto;  \n  padding: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    text-align: right;\n    width: 100%;\n    background-color: #150a1c;\n    padding: 10px 5px 0 0;\n    margin: 10px 0;\n    @media (max-width:641px)  { /* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */\n        text-align: center;\n        width: 100%;\n        padding: 10px 5px 0px 0px;\n        margin: 10px 0px;\n      }\n'], ['\n    text-align: right;\n    width: 100%;\n    background-color: #150a1c;\n    padding: 10px 5px 0 0;\n    margin: 10px 0;\n    @media (max-width:641px)  { /* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */\n        text-align: center;\n        width: 100%;\n        padding: 10px 5px 0px 0px;\n        margin: 10px 0px;\n      }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    color: #FF00EA;\n    display: inline-block;\n    text-decoration: none;\n    font-size: 20px;\n    font-family: Lato, sans-serif;\n    font-weight:\'300\';\n'], ['\n    color: #FF00EA;\n    display: inline-block;\n    text-decoration: none;\n    font-size: 20px;\n    font-family: Lato, sans-serif;\n    font-weight:\'300\';\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(21);

var _styledComponents = __webpack_require__(45);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PageContent = _styledComponents2.default.div(_templateObject);
var Nav = _styledComponents2.default.nav(_templateObject2);

var NavLink = _styledComponents2.default.div(_templateObject3);

var styles = {
    navA: _defineProperty({
        color: '#FF00EA',
        padding: '1rem',
        display: 'inlineBlock',
        textDecoration: 'none',
        fontWeight: 'bold',
        fontSize: '20px',
        fontFamily: 'Lato, sans-serif',
        margin: '5px'
    }, 'fontWeight', '300')
};

var ActiveStyle = {
    fontWeight: 'bold',
    color: '#108db8'
};

exports.default = function (_ref) {
    var children = _ref.children;
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            Nav,
            null,
            _react2.default.createElement(
                NavLink,
                null,
                _react2.default.createElement(
                    _reactStatic.Link,
                    { style: styles.navA, to: '/' },
                    'Home'
                )
            ),
            _react2.default.createElement(
                NavLink,
                null,
                _react2.default.createElement(
                    _reactStatic.Link,
                    { style: styles.navA, to: '/about', activeStyle: ActiveStyle },
                    'About'
                )
            ),
            _react2.default.createElement(
                NavLink,
                null,
                _react2.default.createElement(
                    _reactStatic.Link,
                    { style: styles.navA, to: '/blog', activeStyle: ActiveStyle },
                    'Blog'
                )
            ),
            _react2.default.createElement(
                NavLink,
                null,
                _react2.default.createElement(
                    _reactStatic.Link,
                    { style: styles.navA, to: '/projects', activeStyle: ActiveStyle },
                    'Projects'
                )
            )
        ),
        _react2.default.createElement(
            PageContent,
            { className: '' },
            children
        )
    );
};

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  color: #FF00EA;\n'], ['\n  color: #FF00EA;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PageLayout = __webpack_require__(142);

var _PageLayout2 = _interopRequireDefault(_PageLayout);

var _styledComponents = __webpack_require__(45);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
//


var MessageText = _styledComponents2.default.h1(_templateObject);

exports.default = function () {
  return _react2.default.createElement(
    _PageLayout2.default,
    null,
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        MessageText,
        null,
        '404 - We couldn\'t find that page :('
      )
    )
  );
};

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/404.2cb28747.js